import React from 'react';
import styled from 'styled-components';

const DiscordSection = styled.section`
	height: 100vh;
	// padding: 32rem 0;
	display: grid;
	grid-template-columns: repeat(12, 1fr);
	grid-gap: 4rem;
	align-items: end;
	justifu-content: center;

	transform: translateY(50px);
 	opacity: 0;	
	animation-name: fadeInUp;
	animation-duration: 0.6s;
	animation-iteration-count: 1;
	animation-fill-mode: forwards;
	animation-timing-function: cubic-bezier(.2,.3,0,1);
	animation-delay: 1.2s;
	backface-visibility: hidden;
    perspective: 100px;
	
	p {
		grid-row: 1;
		grid-column: 5 / span 4;
		text-align: center;
		font-size: 4rem;
	}

	@media(max-width: 900px) {
		grid-column-gap: 0rem;

		p {
			grid-column: 2 / -2;
		}
	}
`

const JoinButton = styled.a`
	grid-row: 2;
	grid-column: 6 / span 2;
	text-align: center;
	align-self: start;
	background: #FFCA77;
	color: #2C2E32;
	padding: 2rem;
	transform: scale(1);
	transition: transform 0.3s cubic-bezier(.2,.3,0,1);
	backface-visibility: hidden;
    perspective: 100px;

	&:hover {
		transform: scale(1.1);
	}


	&:after {
		display: none;
	}

	@media(max-width: 900px) {
		grid-column: 2 / -2;	
	}
`

const Discord = ({data}) => (
	<DiscordSection>
		<p>{data.join_text}</p>
		<JoinButton href={data.join_url}>Join!</JoinButton>
	</DiscordSection>
)

export default Discord;



// WEBPACK FOOTER //
// ./src/compontents/discord.js